// extracted by mini-css-extract-plugin
module.exports = {"container":"style-module_container__16YXtZ1IVgIphzKm9IsOZt","spacer":"style-module_spacer__2o6ch-DgesBBD35p64-wke"};